import Bold from '@components/atoms/text/bold';
import DetailItemContainer from '@components/atoms/container/detailItemContainer';
import DetailItemTitleContainer from '@components/atoms/container/detailItemTitleContainer';
import DetailItemValueContainer from '@components/atoms/container/detailItemValueContainer';
import DetailText from '@components/atoms/text/detailText';

interface Props {
  title?: string;
  value?: string;
}

export default function DetailItem({ title, value }: Props) {
  return title && value ? (
    <DetailItemContainer id={'detailItem'}>
      <DetailItemTitleContainer>
        <DetailText>
          <Bold id={'itemTitle'}>{title}</Bold>
        </DetailText>
      </DetailItemTitleContainer>
      <DetailItemValueContainer>
        <DetailText id={'itemValue'}>{value}</DetailText>
      </DetailItemValueContainer>
    </DetailItemContainer>
  ) : null;
}
